import { isWeb } from './platformUtils';
import * as FileSystem from 'expo-file-system';

export const calcDimensionsToFillContainer = (
	containerHeight,
	containerWidth,
	objHeight,
	objWidth,
	cover=false,
) => {
	let res = {
		maxHeight: 0,
		maxWidth: 0,
		scale: 0,
	};
	if (containerHeight
		&& containerWidth
		&& objHeight
		&& objWidth
		&& containerHeight * containerWidth * objHeight * objWidth > 0
	) {
		const heightScale = objHeight / containerHeight;
		const widthScale = objWidth / containerWidth;
		const scale = (cover) ? Math.min(heightScale, widthScale) : Math.max(heightScale, widthScale);
		if(scale > 0) {
			res.scale = scale;
			res.maxHeight = objHeight / scale;
			res.maxWidth = objWidth / scale;
		}
	}
	return res;
};

// For expo image picker. Verifies image exists and formats a b64 data uri from image data
export const expoImagePickerToBase64 = (image) => {
	let b64Image;
	if (!image.canceled) {
		if (isWeb && image.uri ) b64Image = image.uri;
		else if (image.uri && image.base64) {
			const imageType = image.uri.split('.').slice(-1)[0];
			if (imageType && (
				imageType.toLowerCase() === 'jpeg'
				|| imageType.toLowerCase() === 'png')
			) b64Image = `data:image/${imageType};base64,${image.base64}`;
		}
	}
	return b64Image;
};

async function convertBase64ToPNG(base64Image) {
	const imageUri = `${FileSystem.cacheDirectory}${(Math.random() * 100000).toFixed(0)}.png`;
	try {
		// Decode the base64 image and write it to a image
		await FileSystem.writeAsStringAsync(imageUri, base64Image, {
			encoding: FileSystem.EncodingType.Base64,
		});

		return imageUri;
	} catch (error) {
		console.error('Error converting base64 to PNG:', error);
		return null;
	}
}

export const b64ToBlob = async (b64) => {
	if (isWeb) return await fetch(b64).then(res => res.blob());
	else {
		const b64Short = b64.split(';base64,')[1];
		return await convertBase64ToPNG(b64Short);
	}
};

// Convert to b64 to avoid CORs issue on s3 image.
// image.crossOrigin = 'anonymous'; // Only partially fixes insecure image upload bug.
// https://stackoverflow.com/questions/17035106/context-getimagedata-operation-is-insecure
const toDataURL = async (url) => fetch(url)
	.then(response => response.blob())
	.then(blob => new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	}));
export const urlToB64 = async (url) => await toDataURL(url)
	.then(dataUrl => {
		const b64string = dataUrl.split('base64,')[1];
		return `data:image/png;base64,${b64string}`;
	});